import { IDatasource, Schema } from "@cak-legacy/generation-core";
import { Form, SelectLibrary } from "@cak-legacy/generation-form";
import * as H from "history";
import * as React from "react";
import { FormBaseComponentState } from "../Interfaces/form-base-component-state";
import { translate } from "../Locales/translator";

export interface IFormulierPaginaProps<T> {
  introText?: JSX.Element;
  introConfirmPageText?: JSX.Element;
  getSchema: () => Schema;
  values: T | undefined;
  defaultValues: T;
  onShowButtons?: (values: T) => boolean;
  datasources?: IDatasource[];
  setValues: (values: T) => void;
  handleReset: () => T;
  history: H.History<unknown>;
  sessionId: number;
  setSessionId: (value: number) => void;
  setFormState: (value: FormBaseComponentState) => void;
}

export const FormulierPagina = <T extends unknown>(props: IFormulierPaginaProps<T>) => {
  const buttons: any = {
    submit: { label: translate("Volgende"), id: "volgendeButton" }
  };

  return (
    <>
      {props.introText}
      <p>{translate("DeVeldenMetEenzijnVerplicht")}</p>
      <Form
        formOptions={{
          defaultValues: (props.values as any) || props.defaultValues
        }}
        onShowButtons={props.onShowButtons}
        uiDefaults={{ flexDirectionFormGroupControl: "row" }}
        fieldDefaults={{
          text: {
            maxLengthMessage: true
          },
          textArea: {
            counterAndMaxLengthMessage: true,
            counterUnit: translate("tekens")
          },
          select: {
            library: SelectLibrary.DownShift
          }
        }}
        dependsOn={{
          keepDefaultValues: true
        }}
        datasources={props.datasources || []}
        handleReset={() => {
          props.setValues(props.handleReset());
        }}
        handleSubmit={(formValues: T) => {
          props.history.replace({
            state: {
              formState: FormBaseComponentState.EnterData,
              values: formValues,
              isSuccesvolVerzonden: false,
              sessionId: props.sessionId
            }
          });
          props.setValues(formValues);
          props.setSessionId(props.sessionId + 1);
          props.setFormState(FormBaseComponentState.ConfirmForm);
        }}
        buttons={buttons}
        schema={props.getSchema()}
      />
    </>
  );
};
